module.exports = __webpack_public_path__ + "img/DSC_1979.9ae001b6.JPG";